<script>
export default {
    name: "ConfirmApprovalModal",
    props: {
        stockTransferLineItem: Array,
        showModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        confirmApproval () {
            this.$root.loading = true;

            this.$accountsHttp.post('StockTransfer/ApproveStockTransfer', { 'stockTransferLineItem' : this.stockTransferLineItem })
                .then(response => {
                this.$root.loading = false;
                this.$emit('refreshPage');
                window.Swal.fire({ text: response.data, type: 'success', showCancelButton: false });
            }).catch(() => this.$root.loading = false); 
        }
    }
}
</script>

<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-10/12">
        <template v-slot:title>
            <h5 class="text-left font-semibold text-sm">Confirm Approval</h5>
        </template>
        <template v-slot:modal-body>
           <div class="w-full flex flex-wrap overflow-auto -m-3">
               <table class="table">
                   <thead class="bg-blue-500 text-xs text-white">
                       <tr>
                           <th class="p-tiny">Code</th>
                           <th class="p-tiny">Item Name</th>
                           <th class="p-tiny">TransferCode</th>
                           <th class="p-tiny">Username</th>
                       </tr>
                   </thead>
                   <tbody class="text-xs bg-gray-100">
                       <tr v-for="(transfer, index) in stockTransferLineItem" :key="index">
                           <td class="p-tiny">{{ transfer.itemId }}</td>
                           <td class="p-tiny">{{ transfer.itemName }}</td>
                           <td class="p-tiny">{{ transfer.transferCode }}</td>
                           <td class="p-tiny">{{ transfer.userName }}</td>
                       </tr>
                   </tbody>
               </table>
           </div>
        </template>
        <template v-slot:modal-footer>
           <button class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.stop="$emit(`closeModal`)">
               <i class="fa fa-times"></i> Cancel</button>
           <button class="btn-primary btn-sm text-xs rounded" 
                @click.prevent="confirmApproval">
                    <i class="fa fa-check"></i> Confirm</button>
        </template>
    </tail-modal>
</template>
